/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Problem,
  ProblemReportNotificationTarget
} from '../model';

import { orvalClient } from '../../orval-client';




export type getAdminProblemReportNotificationTargetResponse200 = {
  data: ProblemReportNotificationTarget
  status: 200
}

export type getAdminProblemReportNotificationTargetResponse401 = {
  data: Problem
  status: 401
}

export type getAdminProblemReportNotificationTargetResponse403 = {
  data: Problem
  status: 403
}

export type getAdminProblemReportNotificationTargetResponse404 = {
  data: Problem
  status: 404
}

export type getAdminProblemReportNotificationTargetResponse409 = {
  data: Problem
  status: 409
}

export type getAdminProblemReportNotificationTargetResponse422 = {
  data: Problem
  status: 422
}

export type getAdminProblemReportNotificationTargetResponse429 = {
  data: Problem
  status: 429
}

export type getAdminProblemReportNotificationTargetResponse500 = {
  data: Problem
  status: 500
}

export type getAdminProblemReportNotificationTargetResponse503 = {
  data: Problem
  status: 503
}

export type getAdminProblemReportNotificationTargetResponseSuccess = (getAdminProblemReportNotificationTargetResponse200) & {
  headers: Headers;
};
export type getAdminProblemReportNotificationTargetResponseError = (getAdminProblemReportNotificationTargetResponse401 | getAdminProblemReportNotificationTargetResponse403 | getAdminProblemReportNotificationTargetResponse404 | getAdminProblemReportNotificationTargetResponse409 | getAdminProblemReportNotificationTargetResponse422 | getAdminProblemReportNotificationTargetResponse429 | getAdminProblemReportNotificationTargetResponse500 | getAdminProblemReportNotificationTargetResponse503) & {
  headers: Headers;
};

export type getAdminProblemReportNotificationTargetResponse = (getAdminProblemReportNotificationTargetResponseSuccess | getAdminProblemReportNotificationTargetResponseError)

export const getGetAdminProblemReportNotificationTargetUrl = (notificationId: string,) => {




  return `/api/v1/admin/problem-reports/notifications/${notificationId}/target`
}

/**
 * Private/no-store; canonical context required, view-as forbidden. History remains available when reporting is disabled. No generic notifications capability required. Own scope always requires current user and organization; admin scope requires current review authority. Missing, hidden or mismatched targets return the same safe 404.
 * @summary Resolve current recipient notification to an independently authorized admin report target.
 */
export const getAdminProblemReportNotificationTarget = async (notificationId: string, options?: RequestInit): Promise<getAdminProblemReportNotificationTargetResponse> => {

  return orvalClient<getAdminProblemReportNotificationTargetResponse>(getGetAdminProblemReportNotificationTargetUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminProblemReportNotificationTargetQueryKey = (notificationId: string,) => {
    return [
    `/api/v1/admin/problem-reports/notifications/${notificationId}/target`
    ] as const;
    }


export const getGetAdminProblemReportNotificationTargetQueryOptions = <TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = Problem>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminProblemReportNotificationTargetQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>> = ({ signal }) => getAdminProblemReportNotificationTarget(notificationId, { signal });





   return  { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminProblemReportNotificationTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>>
export type GetAdminProblemReportNotificationTargetQueryError = Problem


export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve current recipient notification to an independently authorized admin report target.
 */

export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminProblemReportNotificationTargetQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






